import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

import { HttpClientModule } from '@angular/common/http';
import { UserService } from './services/user.service';
import { ModulesComponent } from './modules/modules.component';
import { IconsComponent } from './shared/components/icons/icons.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagComponent } from './shared/components/tag/tag.component';
import { EllipsisComponent } from './shared/components/ellipsis/ellipsis.component';
import { CardComponent } from './shared/components/card/card.component';
import { EditorComponent } from './editor/editor.component';
import { QuillModule } from 'ngx-quill';
import { DefaultComponent } from './layouts/default/default.component';
import { ModalComponent } from './layouts/modal/modal.component';
import { SignupComponent } from './authentication/signup/signup.component';
import { LoginComponent } from './authentication/login/login.component';
import { HomeComponent } from './public/home/home.component';
import { NavProfileComponent } from './shared/components/nav-profile/nav-profile.component';
import { DashboardComponent } from './protected/dashboard/dashboard.component';
import { EditProfileComponent } from './protected/modal/edit-profile/edit-profile.component';
import { GuideComponent } from './protected/modal/guide/guide.component';
import { ApproachesComponent } from './public/approaches/approaches.component';
import { ForumComponent } from './protected/forum/forum.component';
import { ResourcesComponent } from './protected/resources/resources.component';
import { MembersComponent } from './protected/members/members.component';
import { InstitutionsComponent } from './protected/institutions/institutions.component';
import { ProjectsComponent } from './protected/projects/projects.component';
import { EventsComponent } from './protected/events/events.component';
import { JobsComponent } from './protected/jobs/jobs.component';
import { LockedComponent } from './protected/locked/locked.component';
import { InviteComponent } from './protected/modal/invite/invite.component';
import { EditInstitutionComponent } from './protected/modal/edit-institution/edit-institution.component';
import { EditDiscussionComponent } from './protected/modal/edit-discussion/edit-discussion.component';
import { EditProjectComponent } from './protected/modal/edit-project/edit-project.component';
import { EditResourceComponent } from './protected/modal/edit-resource/edit-resource.component';
import { EditEventComponent } from './protected/modal/edit-event/edit-event.component';
import { InfoComponent } from './shared/components/info/info.component';
import { SettingsComponent } from './protected/settings/settings.component';
import { EditJobComponent } from './protected/modal/edit-job/edit-job.component';
import { AddDiscussionComponent } from './protected/modal/add-discussion/add-discussion.component';
import { ForumSingleComponent } from './protected/forum/forum-single/forum-single.component';
import { ProjectSingleComponent } from './protected/projects/project-single/project-single.component';
import { MyListsComponent } from './protected/my-lists/my-lists.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { SingleMemberComponent } from './protected/members/single-member/single-member.component';
import { FilterComponent } from './shared/components/filter/filter.component';
import { AddResourceComponent } from './protected/modal/add-resource/add-resource.component';
import { ResourceSingleComponent } from './protected/resources/resource-single/resource-single.component';
import { JobsSingleComponent } from './protected/jobs/jobs-single/jobs-single.component';
import { EventsSingleComponent } from './protected/events/events-single/events-single.component';
import { InstitutionsSingleComponent } from './protected/institutions/institutions-single/institutions-single.component';
import { ApproachesSingleComponent } from './public/approaches/approaches-single/approaches-single.component';
import { AboutComponent } from './public/about/about.component';
import { SingleHeadingComponent } from './shared/components/single-heading/single-heading.component';
import { TransferRolesComponent } from './protected/modal/transfer-roles/transfer-roles.component';
import { MentionModule } from 'angular-mentions';
import { DisabledComponent } from './protected/modal/disabled/disabled.component';
import { NotificationsComponent } from './protected/notifications/notifications.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PrivacyComponent } from './protected/modal/privacy/privacy.component';
import { TermsComponent } from './protected/modal/terms/terms.component';
import { DisclaimerComponent } from './protected/modal/disclaimer/disclaimer.component';
import { UserDeletedComponent } from './protected/modal/user-deleted/user-deleted.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ModulesComponent,
    IconsComponent,
    TagComponent,
    EllipsisComponent,
    EditorComponent,
    CardComponent,
    DefaultComponent,
    ModalComponent,
    SignupComponent,
    LoginComponent,
    NavProfileComponent,
    DashboardComponent,
    EditProfileComponent,
    GuideComponent,
    ApproachesComponent,
    ForumComponent,
    ResourcesComponent,
    MembersComponent,
    InstitutionsComponent,
    ProjectsComponent,
    EventsComponent,
    JobsComponent,
    LockedComponent,
    InviteComponent,
    EditInstitutionComponent,
    EditDiscussionComponent,
    EditProjectComponent,
    EditResourceComponent,
    EditEventComponent,
    InfoComponent,
    SettingsComponent,
    EditJobComponent,
    AddDiscussionComponent,
    ForumSingleComponent,
    ProjectSingleComponent,
    MyListsComponent,
    SingleMemberComponent,
    FilterComponent,
    AddResourceComponent,
    ResourceSingleComponent,
    JobsSingleComponent,
    EventsSingleComponent,
    InstitutionsSingleComponent,
    ApproachesSingleComponent,
    AboutComponent,
    SingleHeadingComponent,
    TransferRolesComponent,
    DisabledComponent,
    NotificationsComponent,
    PrivacyComponent,
    TermsComponent,
    DisclaimerComponent,
    UserDeletedComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireModule.initializeApp(environment.firebase),
    FormsModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    HttpClientModule,
    MentionModule,
    PdfViewerModule,
  ],
  providers: [UserService],
  bootstrap: [AppComponent],
})
export class AppModule {}
